// TemplateEnums.js

/**
 * Enumeration constants used by TemplateManager and PromptBuilder
 * to provide select/autocomplete options for template metadata.
 */
export const DOMAIN_OPTIONS = [
    "Auto",
    "General",
    "STEM",
    "Vocational / Trades",
    "Business",
    "Humanities",
    "Interdisciplinary",
    "Arts"
  ];
  
  export const READING_LEVEL_OPTIONS = [
    "Auto",
    "grade-6",
    "grade-8",
    "grade-11",
    "undergrad",
    "professional"
  ];
  
  export const TONE_OPTIONS = [
    "Auto",
    "friendly",
    "conversational",
    "professional",
    "formal",
    "storytelling",
    "inspirational"
  ];
  
  export const CITATION_STYLE_OPTIONS = [
    "Auto",
    "APA",
    "MLA",
    "IEEE"
  ];
  
  export const MEDIA_DENSITY_OPTIONS = [
    "Auto",
    "none",
    "low",
    "medium",
    "high"
  ];
  
  export const CODE_LANGUAGE_OPTIONS = [
    "Auto",
    "C",
    "Python",
    "JavaScript",
    "C++",
    "Java",
    "R",
    "MATLAB",
    "SQL",
    "Scratch"
  ];
  
  export const LANGUAGE_OPTIONS = [
    "English",
    "Dutch",
    "French",
    "German",
    "Spanish",
    "Telugu"
  ];
  